import React from 'react'

export default ({ chapters }) => <div><h1 id="sample">Sample Chapters</h1>

  <p>Below are a few chapters from the book.</p>
  <ul>
    {chapters.map((ch, i) => <li key={i}><a href={`#${ch.title}`}>{ch.title}</a></li>)}
  </ul>

  {chapters.map((ch, i) => <div key={i} className="chapter">
    <h2 id={`${ch.title}`}>{ch.title}</h2>
    <div dangerouslySetInnerHTML={{__html:ch.content}} />
  </div>)}
</div>


// WEBPACK FOOTER //
// ./src/components/SampleChapters.js